export default function About() {
  return (
    <div className="page">
      <div className="page-container">
        <header className="page-header">
          <h1 className="page-title">About ASDRY</h1>
        </header>

        <div className="content-card">
          <div className="card-body">
            <p>
              ASDRY is a beta environmental preparation app built to help people
              understand what weather and environmental conditions may mean for
              the activity they are planning.
            </p>

            <p>
              Weather forecasts are useful, but they usually stop at the data:
              temperature, rain, wind, cloud, and other forecast values. ASDRY is
              being built to add the missing layer — practical preparation guidance
              for real activities.
            </p>

            <p>
              The current ASDRY Beta focuses on everyday outdoor checks such as
              running, walking, commuting, cycling, dog walking, gardening, hanging
              washing, and other activity-based plans. The aim is simple: help users
              understand what to expect, what to watch out for, and how to prepare.
            </p>

            <p>
              Founded by Philip Jakeman in the UK, ASDRY began with a simple
              frustration: forecasts describe the weather, but they rarely describe
              what that weather means for a real person making a real decision.
              ASDRY was built to bridge that gap — not by predicting more, but by
              interpreting better.
            </p>

            <p>
              ASDRY is being developed through real-world testing, including
              everyday activity checks, user feedback, and Parkrun field testing.
              That feedback helps shape the guidance and improve the product over
              time.
            </p>

            <p>
              <strong>Mission:</strong> Turn weather and environmental data into
              clear preparation guidance people can actually use.
            </p>

            <p>
              <strong>Principles:</strong>
            </p>

            <ul>
              <li>
                <strong>Useful first</strong> — guidance should help people decide
                what to do, not just show more weather data.
              </li>
              <li>
                <strong>Activity aware</strong> — the same weather can matter
                differently for a runner, walker, cyclist, volunteer, or outdoor
                worker.
              </li>
              <li>
                <strong>Honest development</strong> — ASDRY Beta is live now, while
                deeper planning, Pro, Business, and API features are still being
                shaped through testing and feedback.
              </li>
            </ul>

            <hr className="content-divider" />

            <h2 className="content-subtitle">Where ASDRY is heading</h2>

            <p>
              The current beta is focused on personal preparation guidance. Longer
              term, the same engine may support deeper planning tools, event
              readiness, outdoor work, and business use cases.
            </p>

            <hr className="content-divider" />

            <h2 className="content-subtitle">Further Reading</h2>

            <p>
              For deeper insight into the thinking behind ASDRY and why weather
              forecasts often need interpretation, explore the following articles:
            </p>

            <ul>
              <li>
                <a href="/blog/why-weather-forecasts-are-often-right-and-still-let-us-down">
                  Why Weather Forecasts Are Often Right — and Still Let Us Down
                </a>
              </li>
              <li>
                <a href="/blog/behind-asdry-why-im-building-a-decision-first-weather-engine">
                  Behind ASDRY: Why I’m Building a Decision‑First Weather Engine
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}